import BaseComponent from '@/components/base';
import { style } from './style';

export default class CountDownTimer extends BaseComponent {
  constructor() {
    super();
    this.countdownInterval = null;
    this.endDateTime = null;
  }

  static get observedAttributes() {
    return [
      'data-end-date',
      'data-end-time',
      'data-countdown-message',
      'data-render-next-to',
      'data-top-spacing',
      'data-bottom-spacing'
    ];
  }

  render() {
    const endDate = this.getAttribute('data-end-date');
    const endTime = this.getAttribute('data-end-time') || '23:59:59';
    const countdownMessage =
      this.getAttribute('data-countdown-message') ||
      '<p>Limited Time Offer</p>';
    const topSpacing = this.getAttribute('data-top-spacing') || '20';
    const bottomSpacing = this.getAttribute('data-bottom-spacing') || '20';

    // Validate dates
    if (!endDate) {
      return `${style(
        topSpacing,
        bottomSpacing
      )}<div class="countdown-timer"><p>No end date provided</p></div>`;
    }

    // Create end date
    this.endDateTime = new Date(endDate + 'T' + endTime + 'Z');
    const now = new Date();

    // Check if countdown should be shown
    if (this.endDateTime <= now) {
      return `${style(
        topSpacing,
        bottomSpacing
      )}<div class="countdown-timer"><div class="countdown-expired">Offer Expired</div></div>`;
    }

    return `
      ${style(topSpacing, bottomSpacing)}
      <div class="countdown-timer">
        <div class="countdown-container">
          <div class="countdown-message">
            ${countdownMessage}
          </div>
          <div class="countdown-display" id="countdown-display">
            <div class="countdown-item">
              <span class="countdown-number" id="days">00</span>
              <span class="countdown-label">Days</span>
            </div>
            <span class="countdown-separator">:</span>
            <div class="countdown-item">
              <span class="countdown-number" id="hours">00</span>
              <span class="countdown-label">Hours</span>
            </div>
            <span class="countdown-separator">:</span>
            <div class="countdown-item">
              <span class="countdown-number" id="minutes">00</span>
              <span class="countdown-label">Minutes</span>
            </div>
            <span class="countdown-separator">:</span>
            <div class="countdown-item countdown-seconds" id="seconds-container">
              <span class="countdown-number" id="seconds">00</span>
              <span class="countdown-label">Seconds</span>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  afterMount() {
    this.handleRenderNextTo();
    this.startCountdown();
  }

  startCountdown() {
    if (!this.endDateTime) return;

    // Clear any existing interval
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    // Update immediately
    this.updateCountdown();

    // Update every second
    this.countdownInterval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  updateCountdown() {
    const countdownDisplay =
      this.shadowRoot.querySelector('#countdown-display');
    if (!countdownDisplay || !this.endDateTime) return;

    const now = new Date();
    const timeLeft = this.endDateTime - now;

    if (timeLeft <= 0) {
      countdownDisplay.innerHTML =
        '<div class="countdown-expired">Offer Expired</div>';
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
      return;
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    // Update elements
    const daysElement = this.shadowRoot.querySelector('#days');
    const hoursElement = this.shadowRoot.querySelector('#hours');
    const minutesElement = this.shadowRoot.querySelector('#minutes');
    const secondsElement = this.shadowRoot.querySelector('#seconds');

    if (daysElement) daysElement.textContent = days.toString().padStart(2, '0');
    if (hoursElement)
      hoursElement.textContent = hours.toString().padStart(2, '0');
    if (minutesElement)
      minutesElement.textContent = minutes.toString().padStart(2, '0');
    if (secondsElement)
      secondsElement.textContent = seconds.toString().padStart(2, '0');
  }

  handleRenderNextTo() {
    const renderNextTo = this.getAttribute('data-render-next-to');
    if (renderNextTo) {
      const element = document.querySelector(renderNextTo);
      if (element) {
        element.appendChild(this);
      }
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);

    if (name === 'data-end-date' || name === 'data-end-time') {
      const endDate = this.getAttribute('data-end-date');
      const endTime = this.getAttribute('data-end-time') || '23:59:59';

      if (endDate) {
        this.endDateTime = new Date(endDate + 'T' + endTime + 'Z');
        this.startCountdown();
      }
    }

    if (name === 'data-top-spacing' || name === 'data-bottom-spacing') {
      // Re-render the component to apply new spacing
      this.render();
    }
  }

  disconnectedCallback() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }
}
